import { render, staticRenderFns } from "./subscription-block.vue?vue&type=template&id=6b65e422&"
import script from "./subscription-block.vue?vue&type=script&lang=js&"
export * from "./subscription-block.vue?vue&type=script&lang=js&"
import style0 from "./subscription-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b65e422')) {
      api.createRecord('6b65e422', component.options)
    } else {
      api.reload('6b65e422', component.options)
    }
    module.hot.accept("./subscription-block.vue?vue&type=template&id=6b65e422&", function () {
      api.rerender('6b65e422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/footer/subscription-block.vue"
export default component.exports